import { Store } from "../config/store";
import { ProfileSettings, UserSettings } from "../types/app.storage.enums";

export const setStringToStorage = (key: string, value: string) => {
  Store.setItem(key, value);
};

export const setObjectToStorage = <T>(key: string, value: T) => {
  Store.setItem(key, JSON.stringify(value));
};

export const getStringFromStorage = (key: string) => {
  return Store.getItem(key);
};

export const getObjectFromStorage = <T>(key: string): T => {
  try {
    return JSON.parse(Store.getItem(key));
  } catch (_ex) {
    return null;
  }
};

export const removeItemFromStorage = (key: string) => {
  Store.removeItem(key);
};

export const removeProfilePreference = () => {
  Object.entries<ProfileSettings>(ProfileSettings).forEach(([_key, value]): any => {
    removeItemFromStorage(value);
  });
};

export const removeUserPreference = () => {
  Object.entries<UserSettings>(UserSettings).forEach(([_key, value]): any => {
    removeItemFromStorage(value);
  });
  removeProfilePreference();
};

export const clearAllLocalStorage = () => {
  Store.clear();
};
